import { useState, useEffect } from "react";

import {
  Augnito,
  EditorType,
  PhilipsMicMode,
  AugnitoMobileConfig,
} from "augnitosdk";

export const useAugnito = ({ userTag }) => {
  const [augnito, setAugnito] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isError, setIsError] = useState(false);

  const philipMicConfig = {
    philipsMicMode: PhilipsMicMode["HandsFree"],
  };

  const mobileConfig = {
    enableLogs: false,
  };

  const augnitoConfig = {
    server: process.env.REACT_APP_AUGNITO_DOMAIN,
    accountCode: process.env.REACT_APP_AUGNITO_ACCOUNT_CODE,
    accessKey: process.env.REACT_APP_AUGNITO_ACCESS_KEY,
    userTag: userTag,
    sourceApp: "RADISCAN",
    lmId: process.env.REACT_APP_AUGNITO_LMID,
    noiseCt: 1,
    enableLogs: false,
    listOfControls: [],
    editor: EditorType.CKEDITOR4,
  };

  useEffect(() => {
    if (augnito) {
      augnito.initPhilipMicClient(philipMicConfig);

      augnito.onFinalResult = (result) => {};

      augnito.onStateChanged = (isConnected) => {
        setIsConnected(isConnected);
      };

      augnito.onError = (error) => {
        setIsError(true);

        console.log("Error:", error);
      };

      augnito.onPhilipsMicPressed = () => {
        startAugnitoConnection();
      };
    }

    return () => {
      if (augnito) {
        /* 
        call this method to close the socket connection and clear all resources
        in case shouldPauseResume is set to true
        */
        augnito.requestMicOff();
        augnito.dispose();
      }
    };
  }, [augnito]);

  const startAugnitoConnection = () => {
    if (!augnito) {
      const augnitoInstance = new Augnito(augnitoConfig);

      /*
        Toggles the Speech API connection. Set optional parameter shouldPauseResume to true to 
        toggle pause and resume dictation. This will ensure socket connection remains connected 
        throughout. If no parameter is given, then the method will function as toggle of start 
        and stop dictation. This will create a new socket connection on every start
      */
      augnitoInstance.toggleListening(false);

      setAugnito(augnitoInstance);
    } else {
      augnito.toggleListening();
    }
  };

  const stopAugnitoConnection = () => {
    if (augnito) {
      augnito.requestMicOff();
      augnito.dispose();
    }
  };

  const getQRCode = () => {
    const augnitoInstance = new Augnito(augnitoConfig);
    augnitoInstance.initMobileClient(mobileConfig);

    return augnitoInstance.getQRCode();
  };

  return {
    isConnected,
    isError,
    startAugnitoConnection,
    stopAugnitoConnection,
    getQRCode,
  };
};
